import '../css/app.scss';
import './script/neto.js';
import { addEvent, appHeight } from './script/utils';

appHeight();
addEvent();

import popupCalls from './script/popupCalls';
import sliders from './script/slider';
import brands from './script/brands';
import mobMenu from './script/mobMenu';
import stickyHeader from './script/stickyHeader';
import sticky from './script/sticky-line';
import menuCols from './script/menuCols';
import video from './script/video';
import accordian from './script/accordian';
import readMore from './script/readmore';
import showMoreFilters from './script/filterShowmore';
import scrollCart from './script/cartLine';
import scroll from './script/scroll';

popupCalls.init();
sliders.init();
brands.init();
mobMenu.init();
stickyHeader.init();
sticky.init();
menuCols.init();
video.init();
accordian.init();
readMore.init();
showMoreFilters.init();
scrollCart.init();
scroll.init();